import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {ApiService} from './api.service';
import {Response} from '../interfaces/';
import {Observable} from 'rxjs';
import {ReciboPDF} from '../models';
import { environment } from '../../environments/environment';

@Injectable()
export class ReceiptService {

  headers: HttpHeaders;

  constructor(private http: HttpClient, private API: ApiService) {
  }

  listPendingReceipts(data: any): Observable<Response> {
    return this.http.post<Response>(this.API.pendingReceipts, data);
  }

  listPendingReceiptsRuc(data: any): Observable<Response> {
    return this.http.post<Response>(this.API.pendingReceiptsRuc, data);
  }

  registroCobranzaCci(data: any): Observable<Response> {
    // this.headers = new HttpHeaders()
    // .set('Content-Type', 'multipart/form-data');

    // const httpOptions = {
    //   headers: new HttpHeaders({
    //     'Content-Type': 'multipart/form-data'
    //   })
    // };
    // let headers = new HttpHeaders();
    // headers = headers.append('Content-Type', 'multipart/form-data');
    // headers = headers.append('enctype', 'multipart/form-data');
 
    // const formData: FormData = new FormData();
    // formData.append('dataRecibos', data.dataRecibos);
    // formData.append('dataFormulario', data.dataFormulario);
    // formData.append('files', data.files);
    return this.http.post<Response>(this.API.registerCollectionCci, data);
  }      

  guardarAdjunto(data: any): Observable<Response> {
    return this.http.post<Response>(this.API.saveAttachment,data);
  }

  listPaidReceipts(data: any): Observable<Response> {
    return this.http.post<Response>(this.API.paidReceipts,data);
  }

  viewReceipt(element: ReciboPDF): Observable<Response> {
    return this.http.post<Response>(this.API.viewReceipt, element);
  }

  validateReceipt(data: any): Observable<Response> {
    return this.http.post<Response>(this.API.validateReceipt, data);
  }

  detailReceipt(element: any): Observable<Response> {
    return this.http.post<Response>(this.API.detailReceipt, element);
  }

  detailPagos(element: any): Observable<Response> {
    return this.http.post<Response>(this.API.detailPagos, element);
  }

}
